export default __webpack_public_path__ + "static/icon-4-6-69c92a33cd61c9993eecdab4e4b20bfc.png";